import React, { useState, useContext, useEffect } from 'react';
import { IonContent, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonSplitPane, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonSlides } from '@ionic/react';
import { IonTabs, IonTabBar, IonTabButton, IonText, IonLabel, IonFooter, IonSlide, IonImg, IonRouterOutlet } from '@ionic/react';
import { Redirect} from 'react-router-dom';

import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';

//import { JobDescriptionModal } from './Modal_JobDescription';

import '../../css/layout.css';


export function  Client_Jobs () {

    let authenticatedClient_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedClient_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedClient_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedClient_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedClient_context.baseURL);

    let [createRequisitionModal, setCeateRequisitionModal] = useState(false);
    let [viewRequistion_overviewModal, setViewRequistion_overviewModal]= useState(false);
    let [deleteRequisitionModal, setDeleteRequisitionModal] = useState(false);

    let [viewApplicationList, setViewApplicationList] = useState([]);

    let [requisitionID, setRequisitionID] = useState(false);
    let [requisitionName, setRequisitionName] = useState(false);
    let [requisitionResponsibilites, setRequisitionResponsibilites] = useState(false);
    let [requisitionQualifications, setRequisitionQualifications] = useState(false);
    let [requisitionDeadline, setRequisitionDeadline] = useState(false);

    let [showJobDescriptionModal, setShowJobDescriptionModal] = useState(false);


    useEffect(() => {

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                //Tracker: "74503_requisitions_overview",
                Tracker: "uu_applications_sent_list",
                user: acctID,
                sessionID: sessionID,

            }),
        }

        
        fetch(baseURL+'userAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            //alert(res);

            let rows = res.toString().split('~~~');

            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');

                setViewApplicationList((prevViewRequisitionList) => {
                    return prevViewRequisitionList.concat({
                        merchantID: cols[0], 
                        application_id: cols[1], 
                        requisitionName: cols[2], 
                        company_role: cols[3], 
                        applicant_first_name: cols[4], 
                        applicant_middle_name: cols[5], 
                        applicant_last_name: cols[6], 
                        applicant_phone_number: cols[7], 
                        applicant_email_address: cols[8], 
                        date_recieved: cols[9], 
                        application_status: cols[10],
                        application_text: cols[11],
                        merchantName: cols[12],

    
                    })
                });
            } 
        })

    }, [])            
        

    function viewJobDescriptionModalHandler(event)
    {
        setRequisitionID(event[1]);
        setRequisitionName(event[2]);
        setRequisitionResponsibilites(event[3]);
        setRequisitionQualifications(event[4]);
        setRequisitionDeadline(event[5]);

        setShowJobDescriptionModal(event[0]);
    }

    function applicationListHandler(event) {
        
        setRequisitionID(event[1]);
        setViewRequistion_overviewModal(true);

    }


    return (
        <React.Fragment>

            <IonContent className='grid_content'>
                            <IonItem>
                                <IonGrid>
                                    <IonRow style={{color: 'black'}}>
                                        <IonCol>
                                            <h3> APPLICATIONS</h3>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow >
                                        <IonCol size='3' > <h4>Company</h4></IonCol>
                                        <IonCol size='3' ><h4>Role</h4></IonCol>
                                        <IonCol size='3'><h4>Status</h4></IonCol>
                                        <IonCol size='3'><h4>Details</h4></IonCol>
                                    </IonRow>
                                    </IonGrid>
                            </IonItem>
                            <IonGrid >
                                {viewApplicationList.map((detailData) =>   {
                                    return (
                                        <IonRow className='gridResultBody'>
                                            <IonCol size='3' >{detailData.merchantName}</IonCol>
                                            <IonCol size='3' >{detailData.requisitionName}</IonCol>
                                            <IonCol size='3' >{detailData.application_status}</IonCol>
                                            <IonCol size='3' >
                                                {/*<IonButton  > Image </IonButton>*/}
                                                <IonButton  className='small_button' onClick={() => viewJobDescriptionModalHandler([true, detailData.requisitionID, detailData.requisitionName, detailData.requisitionResponsibilites, detailData.requisitionQualifications, detailData.requisitionDeadline])}> Job Post </IonButton>
                                            </IonCol>
                                        </IonRow>
                                    )
                                }
                                )}
                            </IonGrid>

                {/*{showJobDescriptionModal == true && 
                <JobDescriptionModal openModal={ showJobDescriptionModal } closeModal={() => setShowJobDescriptionModal(false)} data={{
                    requisitionID: requisitionID, 
                    requisitionName: requisitionName,
                    requisitionResponsibilites: requisitionResponsibilites,
                    requisitionQualifications: requisitionQualifications,
                    requisitionDeadline: requisitionDeadline,
                                        }}></JobDescriptionModal>}*/}


            </IonContent>

            </React.Fragment>

        )
}